import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../Components/formElements/InputField";
import ItemService from "../../../services/construction_appCommonService";
import ItemServiceV1 from "../../../services/ap_auto_appCommonService";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import toast from "react-hot-toast";
import { getTodaysData } from "../../../common/Validations";
import CustomerConstants from "../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import { getQtnJobList } from "../../../redux/feature/customer_app/customerV1Slice";
import { useDispatch, useSelector } from "react-redux";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
const EntryUpdate = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  // const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  // const [getFileViewData, setFileViewData] = useState(null);
  const failureCashRequest = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getFailureCashRequest] = useState(failureCashRequest);
  const [getShowFailureModal, setShowFailureCashRequest] = useState(false);
  const [loading, setLoading] = useState(false);
  let documentNumber = useSelector(
    (state) => state?.apauto?.budget?.budgetNr,
  );

  const [formInputs, setFormInputs] = useState({
    budgetDate: getTodaysData() || "",
    department: "",
    category: "",
    subCategory: "",
    allocatedAmount: "",
    plannedAmount: "",
    actualAmount: "",
    remainingAmount: "",
    budgetYear: "",
    paymentMode: "",
    remarks: "",
    supportingDocument: "",
  });
  useEffect(() => {
    if (!getDropdownData) return;
    setFormInputs((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.textCode,
      [getDropdownData?.textDesc]: getDropdownData?.textDesc,
    }));
    if (getDropdownData?.textField === "typeS") {
      setFormInputs((prev) => ({
        ...prev,
        typeS: getDropdownData?.name,
      }));
      if (getDropdownData.textField === "checkerName") {
        setFormInputs((prev) => ({
          ...prev,
          checkerName: getDropdownData.name,
          checkerNameCode: getDropdownData.textCode,
          checkerNameDesc: getDropdownData.textDesc,
        }));
      }
    }
  }, [getDropdownData]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {
    budgetDate: getTodaysData() || "",
    department: "",
    category: "",
    subCategory: "",
    allocatedAmount: "",
    plannedAmount: "",
    actualAmount: "",
    remainingAmount: "",
    budgetYear: "",
    paymentMode: "",
    remarks: "",
    supportingDocument: "",
  };
  const handleInputChange = (e) => {
  const { name, value } = e.target;

  setFormInputs((prev) => {
    const updated = {
      ...prev,
      [name]: value,
    };

    // ✅ auto calculate remaining
    const allocated = Number(updated.allocatedAmount) || 0;
    const actual = Number(updated.actualAmount) || 0;

    updated.remainingAmount = allocated - actual;

    return updated;
  });
};

  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };
  // const handleViewFile = (fileAttachmentId) => {
  //   setFileViewData(fileAttachmentId);
  //   setShowFileViewModal(true);
  // };
  // const handleViewFileHide = () => {
  //   setShowFileViewModal(false);
  // };

  //handle cancel modal
  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));
    props.onHide();
  };
  const loadFirstLevelData = async (queryName) => {
    if (!documentNumber) return;
    setLoading(true);

    let obj = {
      queryName: "Get_Budget_Detail",
      documentNumber: documentNumber,
    };

    try {
      const item = await ItemService.generateCustomerQuery(obj);

      if (item?.status === 200) {
        setFormInputs(item?.data[0]);
        console.log(formInputs);
      } else {
        setFormInputs([]);
        console.log(`>> Error: Loading ${queryName}`);
      }
    } catch (error) {
      console.error(`>> API Error: ${queryName}`, error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (documentNumber) {
      loadFirstLevelData("Get_Budget_Detail");
    }
    // eslint-disable-next-line
  }, [documentNumber]);
  const handleUpdate = async () => {
    let obj = {
      ...formInputs,
    };
    setDisabled(true);

    try {
      const item = await ItemServiceV1.updateBudget(obj);
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", {
          duration: 2000,
          position: "top-right",
        });
        setFormInputs(
          item?.data?.length ? item.data : { ...formInputs, ...obj },
        );

        props.onHide();
        await dispatch(
          getQtnJobList({
            queryName: "Get_Budget_List",
            module: "",
            page: 1,
            per_page: 10,
          }),
        );
        navigate(CustomerConstants.CUSTOMER_V4_HB_ENTRY_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Something went wrong. Please try again!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      setDisabled(false);
    }
  };

  const hideFailureModal = () => {
    setShowFailureCashRequest(false);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Budget Details Update
          <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
            {documentNumber}
          </span>{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/*03 */}
        {loading ? (
          <div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-green-500 border-solid"></div>
          </div>
        ) : (
          <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      {/* <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                              <i
                                className={`bi ${
                                  isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility3}
                              ></i>
                            </Col> */}
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">BD</span>
                      </Col>

                      <Col xs={4} md={4} lg={4}>
                        <span className="headerTitle"> Budget Details</span>
                        <span className="subHeaderTitle">Budget details</span>
                      </Col>
                    </Row>
                  </h2>

                  <div>
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <div className="accordion-body">
                            <Row className="pt-2 pb-4">
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  type="date"
                                  // label="Budget Date "
                                  label={
                                    <>
                                      <i className="bi bi-calendar-date labelIcon"></i>
                                      Budget Date
                                    </>
                                  }
                                  name="budgetDate"
                                  id="budgetDate"
                                  value={formInputs?.budgetDate}
                                  onChange={handleInputChange}
                                  // disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <ComboboxField
                                  // label="Department"
                                  label={
                                    <>
                                      <i className="bi bi-building labelIcon"></i>
                                      Department
                                    </>
                                  }
                                  placeholder=""
                                  // data={Departments}
                                  id=""
                                  iconClassName="dropdownIcon"
                                  name="department"
                                  code="department"
                                  description="department"
                                  setValue={formInputs?.department}
                                  getvalue={setDropdownData}
                                  required={true}
                                  // error={validation.country}
                                  // disabled={editMode}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <ComboboxField
                                  // label="Category"
                                  label={
                                    <>
                                      <i className="bi bi-folder labelIcon"></i>
                                      Category
                                    </>
                                  }
                                  placeholder=""
                                  // data={Category}
                                  id="category"
                                  iconClassName="dropdownIcon"
                                  name="category"
                                  code="category"
                                  description="category"
                                  setValue={formInputs?.category}
                                  getvalue={setDropdownData}
                                  required={true}
                                  // error={validation.country}
                                  // disabled={editMode}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  // label="Sub Category"
                                  label={
                                    <>
                                      <i className="bi bi-layers labelIcon"></i>
                                      Sub Category
                                    </>
                                  }
                                  placeholder=""
                                  name="subCategory"
                                  id="subCategory"
                                  // error={validation.subCategory || ""}
                                  value={formInputs?.subCategory || ""}
                                  onChange={handleInputChange}
                                  required={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  // label="Allocated Amount "
                                  label={
                                    <>
                                      <i className="bi bi-wallet2 labelIcon"></i>
                                      Allocated Budget
                                    </>
                                  }
                                  placeholder=""
                                  name="allocatedAmount"
                                  id="allocatedAmount"
                                  // error={validation.allocatedAmount || ""}
                                  value={formInputs?.allocatedAmount || ""}
                                  onChange={handleInputChange}
                                  required={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  // label="Planned Amount "
                                  label={
                                    <>
                                      <i className="bi bi-bar-chart labelIcon"></i>
                                      Planned Amount
                                    </>
                                  }
                                  placeholder=""
                                  name="plannedAmount"
                                  id="plannedAmount"
                                  onChange={handleInputChange}
                                  value={formInputs?.plannedAmount || ""}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  // label="Actual Amount "
                                  label={
                                    <>
                                      <i className="bi bi-receipt labelIcon"></i>
                                      Actual Amount
                                    </>
                                  }
                                  placeholder=""
                                  name="actualAmount"
                                  id="actualAmount"
                                  value={formInputs?.actualAmount || ""}
                                  onChange={handleInputChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  // label="Remaining Amount"
                                  label={
                                    <>
                                      <i className="bi bi-calculator labelIcon"></i>
                                      Remaining Budget
                                    </>
                                  }
                                  placeholder=""
                                  name="remainingAmount"
                                  id="remainingAmount"
                                  // error={validation.remainingAmount || ""}
                                  value={formInputs?.remainingAmount || ""}
                                  onChange={handleInputChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  // label="Budget Year"
                                  label={
                                    <>
                                      <i className="bi bi-calendar3 labelIcon"></i>
                                      Budget Year
                                    </>
                                  }
                                  placeholder=""
                                  name="budgetYear"
                                  id="budgetYear"
                                  // error={validation.budgetYear || ""}
                                  value={formInputs?.budgetYear || ""}
                                  onChange={handleInputChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  // label="Remarks"
                                  label={
                                    <>
                                      <i className="bi bi-chat-left-text labelIcon"></i>
                                      Remarks
                                    </>
                                  }
                                  placeholder=""
                                  name="remarks"
                                  id="remarks"
                                  value={formInputs?.remarks || ""}
                                  onChange={handleInputChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={12}
                                lg={4}
                                className="commLeftRightPadding"
                              >
                                <FileUploadComponent
                                  id="supportingDocument"
                                  name="supportingDocument"
                                  label={
                                    <>
                                      <i className="bi bi-paperclip labelIcon"></i>
                                      Supporting Document
                                    </>
                                  }
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={true} // Change to false for single file selection
                                  required={true}
                                  onSuccessUpload={onSuccessUploadDocumentType}
                                  value={formInputs?.supportingDocument || ""}
                                />
                              </Col>
                              {/* <Col
                                xs={8}
                                md={2}
                                lg={2}
                                className="commLeftRightPadding"
                              >
                                {(formInputs?.supportingDocument && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(
                                        formInputs?.supportingDocument,
                                      )
                                    }
                                  />
                                )) ||
                                  "--"}
                              </Col> */}
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              {
                <Row className="my-4 ">
                  <Col
                    lg={{ span: 2, offset: 8 }}
                    className="d-flex justify-content-end mt-2"
                  >
                    <button
                      className="btnTable btn-danger"
                      onClick={handleCancel}
                      disabled={disabled}
                    >
                      Cancel
                    </button>
                  </Col>
                  <Col lg={2} className="d-flex justify-content-end mt-2">
                    <button
                      className="btnTable"
                      disabled={disabled}
                      onClick={handleUpdate}
                    >
                      Save
                    </button>
                  </Col>
                </Row>
              }
            </div>
          </div>
        )}
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureStockData={getFailureCashRequest}
        />
      </Modal.Body>
    </Modal>
  );
});

export default EntryUpdate;
